import * as React from 'react'
import { connect } from 'react-redux'

import { IconName, IconPrefix } from '@fortawesome/fontawesome'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { RootState } from '../../../store'
import { CountByType } from 'src/lib/interfaces/CountByType.interface'
import { ApplicationStatus, applicationStatusToString } from 'src/lib/interfaces/ApplicationStatus.interface'

const map = require('lodash/map')
const filter = require('lodash/filter')
const includes = require('lodash/includes')

const ALLOWED_STATUSES = [ ApplicationStatus.COMPLETED, ApplicationStatus.IN_REVIEW, ApplicationStatus.INTERVIEW ]

export interface ApplicationsSummaryProps {
  summaryData?: CountByType[]
}

class ApplicationsSummary extends React.PureComponent<ApplicationsSummaryProps> {
  getApplicationStatusString(status: ApplicationStatus): string|undefined {
    return applicationStatusToString(status)
  }

  getApplicationStatusIcon(status: ApplicationStatus): [IconPrefix, IconName] {
    const iconsObject = {
      [ApplicationStatus.STARTED]: ['far', 'keyboard'],
      [ApplicationStatus.COMPLETED]: ['far', 'newspaper'],
      [ApplicationStatus.INTERVIEW]: ['far', 'comments'],
      [ApplicationStatus.IN_REVIEW]: ['far', 'chart-bar']
    }

    return iconsObject[status]
  }

  render() {
    const { summaryData } = this.props

    if (!summaryData) { return null }

    return (
      <div className="d-flex align-items-center mt-3">
        {map(filter(summaryData, status => includes(ALLOWED_STATUSES, status.id)), countByType => {
          const statusTitle = this.getApplicationStatusString(countByType.id as ApplicationStatus)
          if (!statusTitle) { return null }

          const statusIcon = this.getApplicationStatusIcon(countByType.id as ApplicationStatus)

          return (
            <div key={countByType.id} className="ggcard" style={{ marginRight: '20px' }}>
              <div className="card-body d-flex flex-column align-items-center justify-content-center">
                <h5 className="card-title d-flex align-items-center">
                  {statusIcon && 
                    <FontAwesomeIcon
                      size="sm"
                      className="mr-2"
                      icon={statusIcon as any}
                    />
                  }
                  {countByType.count}
                </h5>
                <span className="card-subtitle mt-1">{statusTitle}</span>
              </div>
            </div>
          )
        })}
      </div>
    )
  }
}

const mapStateToProps = (state: RootState) => ({
  summaryData: state.applications.summaryData
})

export default connect(mapStateToProps)(ApplicationsSummary)



// WEBPACK FOOTER //
// ./src/routes/applications/components/ApplicationsSummary.component.tsx